import { render, staticRenderFns } from "./IbLogo.vue?vue&type=template&id=3ce82d62"
import script from "./IbLogo.vue?vue&type=script&lang=js"
export * from "./IbLogo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports